export { default } from "./launcherIcon";
